module.exports = __webpack_public_path__ + "img/complete.b94656bf.png";